module.exports = __webpack_public_path__ + "static/media/ProlitigioLogo_3.8ba73eaa.png";